module.exports = __webpack_public_path__ + "img/ky.ky914210c.svg";